const GetEventTrackingSettings = async eventID => {
    try {
        const response = await fetch(`/api/events/${eventID}/settings/analytics`);

        if (response.status !== 200) return {};

        const { payload } = await response.json();

        return payload;
    } catch (error) {
        return {};
    }
};

export default GetEventTrackingSettings;
